export function isAgentStopped(status: unknown): boolean {
    if (status === 0 || status === '0') {
        return true;
    }

    return String(status ?? '').trim().toLowerCase() === 'stopped';
}

export function getAgentStatusLabel(status: unknown): 'Live' | 'Stopped' | undefined {
    if (status === 1 || status === '1') {
        return 'Live';
    }
    if (isAgentStopped(status)) {
        return 'Stopped';
    }

    const normalized = String(status ?? '').trim().toLowerCase();
    if (normalized === 'live') {
        return 'Live';
    }

    return undefined;
}

export function getAgentStatusTagColor(status: unknown): string {
    return isAgentStopped(status) ? 'red' : 'green';
}